/**
 * Styles pour la modal de chat
 * Design moderne inspiré de la landing page, positionnée en bas à droite comme un vrai chat
 */
export const CHAT_MODAL_STYLES = `
  /* Chat Modal - Positionnement en bas à droite sans overlay */
  .ringado-chat-modal {
    position: fixed !important;
    bottom: 24px !important;
    right: 24px !important;
    width: 380px !important;
    height: 600px !important;
    max-width: calc(100vw - 48px) !important;
    max-height: calc(100vh - 120px) !important;
    background: transparent;
    z-index: 2147483647; /* Valeur max pour être au-dessus de tout */
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1); /* Transition plus smooth et plus longue */
    /* Reset de tous les styles qui pourraient être hérités */
    margin: 0 !important;
    border: none !important;
    transform: translateY(30px) scale(0.92) !important; /* Animation plus subtile */
    /* Pas d'overlay background */
    backdrop-filter: none;
  }

  .ringado-chat-modal.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0) scale(1) !important;
  }

  .ringado-chat-container {
    background: white;
    border-radius: 12px; /* Moins arrondi, inspiré de la landing */
    box-shadow: 
      0 20px 25px -5px rgba(0, 0, 0, 0.15),
      0 10px 10px -5px rgba(0, 0, 0, 0.1),
      0 0 0 1px rgba(0, 0, 0, 0.05);
    
    width: 100%;
    height: 100%;
    
    display: flex;
    flex-direction: column;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1); /* Transition plus smooth et synchronisée */
    border: 1px solid rgba(229, 231, 235, 0.8);
    overflow: hidden;
    
    /* Reset des styles qui pourraient être hérités */
    position: relative;
    margin: 0;
    padding: 0;
  }

  /* Responsive design pour différentes tailles d'écran */
  
  /* Tablettes et grands mobiles (768px et moins) */
  @media (max-width: 768px) {
    .ringado-chat-modal {
      bottom: 16px !important;
      right: 88px !important; /* Ajusté pour mobile */
      width: 300px !important;
      height: min(280px, calc(100vh - 300px)) !important;
      max-width: calc(100vw - 120px) !important;
      max-height: calc(100vh - 250px) !important;
    }
    
    .ringado-chat-container {
      border-radius: 10px;
    }
  }

  /* Mobiles moyens (640px et moins) */
  @media (max-width: 640px) {
    .ringado-chat-modal {
      bottom: 12px !important;
      right: 12px !important;
      left: 12px !important;
      width: auto !important;
      max-width: none !important;
      height: min(calc(100vh - 350px), 250px) !important;
      max-height: calc(100vh - 300px) !important;
    }
    
    .ringado-chat-container {
      border-radius: 8px;
    }
    
    /* Sur mobile, cacher le bouton quand le modal est ouvert pour éviter le chevauchement */
    .ringado-widget.modal-open .ringado-chat-button {
      opacity: 0;
      transform: scale(0.8);
      pointer-events: none;
    }
  }

  /* Petits mobiles (480px et moins) */
  @media (max-width: 480px) {
    .ringado-chat-modal {
      bottom: 8px !important;
      right: 8px !important;
      left: 8px !important;
      top: auto !important;
      height: min(calc(100vh - 300px), 220px) !important;
      max-height: calc(100vh - 250px) !important;
      padding: 0 !important;
    }
    
    .ringado-chat-container {
      width: 100%;
      max-width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }

  /* Très petits écrans (360px et moins) */
  @media (max-width: 360px) {
    .ringado-chat-modal {
      bottom: 4px !important;
      right: 4px !important;
      left: 4px !important;
      height: min(calc(100vh - 280px), 200px) !important;
      max-height: calc(100vh - 220px) !important;
      padding: 0 !important;
    }
    
    .ringado-chat-container {
      border-radius: 8px;
    }
  }

  /* Écrans courts (max-height: 600px) - appareils en mode paysage */
  @media (max-height: 600px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 200px), 180px) !important;
      max-height: calc(100vh - 150px) !important;
    }
  }

  /* Écrans très courts (max-height: 500px) */
  @media (max-height: 500px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 150px), 160px) !important;
      max-height: calc(100vh - 120px) !important;
      bottom: 8px !important;
    }
  }

  /* Mode paysage sur mobile - très compact */
  @media (max-width: 768px) and (orientation: landscape) and (max-height: 500px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 120px), 140px) !important;
      max-height: calc(100vh - 80px) !important;
      bottom: 4px !important;
    }
    
    .ringado-chat-container {
      border-radius: 6px;
    }
  }

  /* Styles spécifiques pour Chrome/Brave mobile avec barre d'URL dynamique */
  @media (max-width: 640px) and (max-height: 700px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 300px), 200px) !important;
      max-height: calc(100vh - 250px) !important;
      bottom: 12px !important;
    }
  }

  /* Écrans mobiles très compacts - priorité absolue à l'accessibilité */
  @media (max-width: 480px) and (max-height: 650px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 280px), 180px) !important;
      max-height: calc(100vh - 220px) !important;
    }
  }

  /* Compact header et footer pour plus d'espace pour les messages */
  @media (max-width: 640px) {
    .ringado-chat-header {
      padding: 6px 10px !important;
      min-height: 40px !important;
      font-size: 14px !important;
    }
    
    .ringado-chat-footer {
      padding: 3px 10px !important;
      font-size: 10px !important;
      line-height: 1.2 !important;
    }
    
    .ringado-input-area {
      padding: 6px 10px !important;
      min-height: 44px !important;
    }
    
    .ringado-messages-container {
      padding: 6px !important;
    }
  }

  /* Ultra compact pour très petits écrans */
  @media (max-width: 480px) {
    .ringado-chat-header {
      padding: 4px 8px !important;
      min-height: 36px !important;
      font-size: 13px !important;
    }
    
    .ringado-chat-footer {
      padding: 2px 8px !important;
      font-size: 9px !important;
    }
    
    .ringado-input-area {
      padding: 4px 8px !important;
      min-height: 40px !important;
    }
    
    .ringado-messages-container {
      padding: 4px !important;
    }
    
    .ringado-input {
      font-size: 14px !important;
      padding: 6px 8px !important;
    }
  }

  /* Animation d'entrée améliorée */
  @keyframes ringado-modal-enter {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(40px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  .ringado-chat-modal.open .ringado-chat-container {
    animation: ringado-modal-enter 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
